import { ApiClient } from './client'
import { PUT_INTRODUCTORY_TEXT } from './endpoints'

export const putIntroductoryText = async (
  targetCompanyId: number,
  content: string,
) => {
  const body = {
    introductory_text: {
      target_company_id: targetCompanyId,
      content: content,
    },
  }
  const res = await ApiClient.put(PUT_INTRODUCTORY_TEXT, body)
  return res.data
}
